import * as Sentry from '@sentry/react';
import config from './config';

export const initSentry = () => {
  if (process.env.NODE_ENV !== 'production') return;
  Sentry.init({
    dsn: config.sentry.dsn,
    // debug: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: true,
        minReplayDuration: 1000,
      }),
      Sentry.dedupeIntegration(),
      Sentry.feedbackIntegration({
        autoInject: false, // Disable the default button so we can use our own
        useSentryUser: {
          email: 'email',
          name: 'name',
        },
        formTitle: 'Give Feedback',
        submitButtonLabel: 'Submit Feedback',
        messagePlaceholder:
          'Share your thoughts! Suggest a feature, report a bug, or share your likes and dislikes. All feedback is welcome.',
        colorScheme: 'dark',
        showBranding: false,
        themeDark: {
          background: '#1e2125', // darkTheme.grey.dark
          inputBorder: '1px solid #80AF01', // darkTheme.bloomfieldGreen
          inputOutlineFocus: '2px solid #80AF01', // darkTheme.bloomfieldGreen
          // submitForeground: '#80AF01', // darkTheme.bloomfieldGreen
          // submitBackground: '#80AF01', // darkTheme.bloomfieldGreen
          // submitBackgroundHover: '#70A111', // darkTheme.bloomfieldGreen
          submitBackground: '#1976d2', // theme.colors.secondary
          submitBackgroundHover: '#125495', // darkTheme.bloomfieldGreen
          submitBorder: '1px solid #80AF01', // darkTheme.bloomfieldGreen
          submitOutlineFocus: '2px solid #80AF01', // darkTheme.bloomfieldGreen

          // submitForeground: '#80AF01', // darkTheme.bloomfieldGreen
        },
      }),
    ],
    tracePropagationTargets: ['localhost', config.api.bloomfieldApiUrl],
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    beforeSend(event) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception) {
        Sentry.showReportDialog({ eventId: event.event_id });
      }
      return event;
    },
  });
};
